module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-Hant":{"exitDebugMode":"關閉 Debug 模式","darkTheme":"深色主題：","preference":"偏好設定...","about":"關於","logout":"登出"},"en":{"exitDebugMode":"Exit debug mode","darkTheme":"Dark Theme: ","preference":"Preference...","about":"About","logout":"Logout"}}')
  delete Component.options._Ctor
}
